import api from "./apiService";

const modeloService = {
  getModelos: async () => {
    let res = await api.get("modelo");
    return res.data;
  },
};

export default modeloService;
